import HTTPServices from "../HTTPServices/httpService";

const workStepServices = {
  //(1)
  searchNameOrPhone: async function (searchWord) {
    console.log("'customerServices' service called: searchword: " + searchWord);
    return await HTTPServices.post("customer/searchNameOrPhone", searchWord);
    // let result =await HTTPServices.post("customer/searchNameOrPhone", searchWord);

    // debugger;
    // console.log('retrun result --->'+ result);
    // return result;
  },

  //(2)
  saveWorkingStep: async function (assignClothToTailorObj) {
    console.log(
      "'assignClothToTailorService Save' service called : " +
        assignClothToTailorObj
    );
    let result = await HTTPServices.post(
      "workingStep/saveWorkingStep",
      assignClothToTailorObj
    );
    // customer.then((result) => {
    //   debugger;
    //   console.log("Promised result: " + result); // "Some desired value"
    //   return result;
    // });

    return result;
  },
};

export default workStepServices;
